<template >
  <div>
    <!-- 查询表单 start-->
    <div class="main_form">
      <el-form :inline="true" :model="queryModel" size="small" ref="queryForm" :rules="rules">
        <el-form-item class="search_form_item" prop="userId">
          <el-input v-model.trim="queryModel.userId" :placeholder="$t('m.live_ID')" maxlength="10" oninput="value=value.replace(/[^\d]/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item class="hidden-xs-only">
          <el-col :span="11">
            <el-form-item prop="applyStartTime" label-width="0">
              <el-date-picker v-model="queryModel.applyStartTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('m.statistical_date')"  style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="fc-text-center" :span="1">~</el-col>
          <el-col :span="11">
            <el-form-item prop="applyEndTime" label-width="0">
              <el-date-picker v-model="queryModel.applyEndTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('m.statistical_date')" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <div class="hidden-sm-and-up">
          <el-form-item>
            <el-col :span="11">
              <div @click="chooseTime('applyStartTime')">
                <el-form-item prop="applyStartTime" label-width="0">
                  <el-date-picker v-model="queryModel.applyStartTime" readonly type="date" value-format="yyyy-MM-dd" :placeholder="$t('m.statistical_date')"  style="width:100%" clearable></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col class="fc-text-center" :span="1">~</el-col>
            <el-col :span="11">
              <div @click="chooseTime('applyEndTime')">
                <el-form-item prop="applyEndTime" label-width="0">
                  <el-date-picker v-model="queryModel.applyEndTime" readonly type="date" value-format="yyyy-MM-dd" :placeholder="$t('m.statistical_date')" style="width:100%" clearable></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-form-item>
          <van-action-sheet v-model="showSelectTime">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title=""
              :min-date="minDate"
              :max-date="maxDate"
              :confirm-button-text="$t('m.Confirm')"
              :cancel-button-text="$t('m.cancel')"
              @confirm="peConfirmTime"
              @cancel="peCancelTime"
            />
          </van-action-sheet>
        </div>
      </el-form>
      <!-- 按钮 -->
      <div class="btn-wrapper">
        <el-button @click="onQueryBtnClick" :disabled='searchBtnTrue' type="primary" size="small">{{$t('m.search')}}</el-button>
        <el-button type="text" size="mini"  @click="resetForm">{{$t('m.reset')}}</el-button>
        <el-button @click="doExportUserDate" type="primary" size="small" class="btn-operation" style="margin-bottom: 10px;">{{$t('m.exported_data')}}</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="main_table">
      <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;" :row-class-name="tableRowClassName" v-loading="loading.table" ref="tableOrder" :element-loading-text="''"
        element-loading-spinner="el-icon-loading">
        <el-table-column prop="userId" :label="$t('m.live_ID')"></el-table-column>
        <el-table-column prop="nickname" :label="$t('m.sereamer_nickname')"></el-table-column>
        <el-table-column prop="state" :label="$t('m.user_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.state ===1 ">{{$t('m.normal')}}</span>
            <span v-if="scope.row.state ===2 ">{{$t('m.temporarily_frozen')}}</span>
            <span v-if="scope.row.state ===3 ">{{$t('m.permanently_frozen')}}</span>
            <span v-if="scope.row.state ===4 ">{{$t('m.cancelled')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dayInCome" :label="$t('m.host_bcoins')"></el-table-column>
        <el-table-column prop="startTime" :label="$t('m.day_anchor_st')"></el-table-column>
        <el-table-column prop="endTime" :label="$t('m.day_anchor_et')"></el-table-column>
        <el-table-column prop="allAwardBcoin" :label="$t('m.total_official')"></el-table-column>
        <el-table-column prop="liveHour" :label="$t('m.live_hour')"></el-table-column>
<!--    扣除B币    -->
        <el-table-column prop="deductBcoin" :label="$t('m.deduct_money')"></el-table-column>
<!--     实际到手收益   -->
        <el-table-column prop="realIncome" :label="$t('m.actual_bcoins_awarded')"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="pager.page"
        :page-sizes="[10, 20, 30, 100, 300, 500]" :page-size="pager.limit" small layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total" :pager-count="5"></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getDayAnchorManageList,
  exportDayUserDate,
} from '../../api/revenues/anchor-revenues';

let queryModelEmpty={
  userId: null,
  applyStartTime: null,
  applyEndTime: null
}
export default {
  name: 'anchor-revenues-page',
  data () {
    return {
      searchBtnTrue: true, // 在生命周期中的列表数据加载完之前搜索按钮是不可点击状态
      guildList: [],
      queryModel: JSON.parse(JSON.stringify(queryModelEmpty)),
      loading: {
        table: true
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      rules: {
        applyStartTime: { validator: this.validateDate, trigger: 'blur' },
        applyEndTime: { validator: this.validateEndDate, trigger: 'blur' },
      },
      tableData: [],
      timeName:'',
      showSelectTime: false,
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2060, 11, 31),
      currentDate: new Date(),
    }
  },
  methods: {
    chooseTime(timeName) {
      this.timeName = timeName
      this.showSelectTime = true
    },
    peConfirmTime(e) {
      let month = e.getMonth() + 1
      let timeStr = e.getFullYear() + '-' + month + '-' + e.getDate()
      this.queryModel[this.timeName] = timeStr
      this.showSelectTime = false
    },
    peCancelTime(e) {
      this.showSelectTime = false
    },
    validateDate(rule, value, callback) {
      if(this.queryModel.applyEndTime != null && this.queryModel.applyStartTime == null) {
        callback(new Error(this.$t('m.select_start_dt')));
      } else if(this.queryModel.applyStartTime && this.queryModel.applyEndTime) {
          let startDt = new Date(this.queryModel.applyStartTime)
          let endDt = new Date(this.queryModel.applyEndTime)
          if(startDt.getTime() > endDt.getTime()) {
            callback(new Error(this.$t('m.less_then_end_dt')));
          }
      }
      callback()
    },
    validateEndDate(rule, value, callback) {
      if(this.queryModel.applyStartTime != null && this.queryModel.applyEndTime == null) {
        callback(new Error(this.$t('m.select_end_dt')));
      } else if(this.queryModel.applyStartTime && this.queryModel.applyEndTime) {
          let startDt = new Date(this.queryModel.applyStartTime)
          let endDt = new Date(this.queryModel.applyEndTime)
          if(startDt.getTime() > endDt.getTime()) {
            callback(new Error(this.$t('m.less_then_end_dt')));
          }
      }
      callback()
    },
    change(e) {
      this.$forceUpdate()
    },
    //重置参数
    resetForm() {
      this.queryModel = JSON.parse(JSON.stringify(queryModelEmpty));
    },

    tableRowClassName({row, column, rowIndex}) {
      row.index = rowIndex;
    },

    activeInputElement() {
      document.activeElement.blur();
      this.$nextTick(() => {
        let inputTime = document.querySelectorAll('.el-input__inner')
        inputTime.forEach(item => {
          item.addEventListener('focus', () => {
            document.activeElement.blur()
          })
        })
      })
    },
    onQueryBtnClick() {
      this.pager.page = 1;
      this.$refs.tableOrder.clearSort();
      this.query();
    },
    query() {
      this.loading.table = true;
      this.getTableData();
    },
    onSizeChange(size) {
      this.pager.limit = size;
      this.query();
    },
    onCurrentPageChange(page) {
      this.pager.page = page;
      this.query();
    },
    getTableData() {
      this.$refs.queryForm.validate(valid => {
        if(valid) {
          // 显示表格loading
          if (this.queryModel.userId > 2147483647) {
            this.loading.table = false;
            this.tableData = [];
            return false;
          }
          this.loading.table = true;
          let obj = Object.assign({}, this.queryModel)
          getDayAnchorManageList({
            query: obj,
            pager: this.pager,
            sorter: this.sorter
          })
            .then(({data}) => {
              this.tableData = data.data.list;
              this.pager.total = data.data.total;
              // 取消loading状态
              this.loading.table = false;
              this.searchBtnTrue = false;
            }).finally(error => {
              this.loading.table = false;
              this.searchBtnTrue = false;
            });
        } else {
          this.loading.table = false;
          this.searchBtnTrue = false;
        }
      })
    },
    // 导出数据
    doExportUserDate() {
      this.$refs.queryForm.validate(valid => {
        if(valid) {
          this.$confirm(this.$t('m.exported_data') + '?', {
            type: "info"
          }).then(() => {
            this.queryModel.exportFileName = "exportFileUserDate";
            let obj = Object.assign({}, this.queryModel)
            exportDayUserDate({query: obj}).then(resp => {
              let a = document.createElement('a');
              let blob = new Blob([resp.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}); // 指定文件MIME
              a.style.display = "none";
              // a.setAttribute('download', 'test');
              // a.download = 'income'; // 指定下载的文件名
              a.href = window.URL.createObjectURL(blob); // URL对象
              document.body.appendChild(a);
              a.click(); // 模拟点击
              URL.revokeObjectURL(blob);
            }).catch(() => {})
          }).catch(() => {})
        }
      })
    }
  },
  mounted() {
    this.getTableData();
  }
}
</script>
<style lang="less" scoped>
  .main_form {
    margin-bottom: 16px;
    padding: 16px;
    background-color: #FFFFFF;
  }

  .main_table {
    padding: 16px;
    background-color: #FFFFFF;
  }
.btn-wrapper{
  /* margin-bottom:20px; */
  min-height:40px;
}
.btn-operation {
  float: right;
}
.ar{
  .btn-operation{
    float: left;
  }
}
/* .el-date-editor.el-input {
  width: 188px;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.coldiv {
  line-height: 2.1;
}
@media screen and (max-width: 1200px) {
  .el-date-editor.el-input {
    width: 155px;
  }
}
@media screen and (max-width: 991px) {
  .coldiv {
    margin-left: 0px;
  }
  .el-date-editor.el-input {
    width: 144px;
  }
}
@media screen and (max-width:768px) {
	.el-date-editor.el-input {
    width: 133px;
	}
}
@media screen and (max-width: 640px) {
	.el-date-editor.el-input {
	  width: 160px;
	}
}
@media screen and (max-width: 480px) {
	.coldiv {margin-left: -5px;}
  .el-date-editor.el-input {
    width: 145px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/pages/revenues/dayAnchorPage.vue